import React, { useEffect, useState } from 'react'
import paybrokersLogo from '../assets/logopix.png'
import { useBalance } from '../BalanceContext';
import { callGetApi, callPostApi } from '../api/ApiCaller';
import { PLAYER_PROFILE_GET, PLAYER_WITHDRAWAL_HISTORY_POST, PLAYER_WITHDRAWAL_POST } from '../api/ApiConst';
import toast from 'react-hot-toast';
import { STATUS } from '../utils/Constants';
import { getCurrencySymbol } from '../utils/TextUtils';


const Withdraw = () => {
    const [activeTab, setActiveTab] = useState("withdrawal");
    const { walletBalance, getWalletBalance, hiddenBalance, setHiddenBalance, profileDetails: globalProfileDetails } = useBalance();
    const [amount, setAmount] = useState("");
    const [loading, setLoading] = useState(false);
    const [transactionType, setTransactionType] = useState("All");
    const [transactions, setTransactions] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [profileDetails, setProfileDetails] = useState(null);
    // Example date range state
    const [startDate, setStartDate] = useState(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]); // 7 days ago
    const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]); // today
    const paymentMethod = {
        name: "PAYBROKERS",
        logo: paybrokersLogo,
        min: 10,
        max: 10000,
        id: "paybrokers",
    };

    const minWithdrawBalance = 10; // Minimum withdrawal amount

    const handleAmountChange = (value) => {
        let numeric = value.replace(/\D/g, "")
        if (!numeric) {
            setAmount("0.00");
            return;
        }
        let floatValue = (parseInt(numeric, 10) / 100).toFixed(2);
        setAmount(floatValue);
    };

    const handleWithdraw = () => {
        setLoading(true);
        callPostApi(PLAYER_WITHDRAWAL_POST, { amount: amount }, {}, (response) => {
            setLoading(false);
            setAmount("");
            toast.success(response.message);
            txnHistory();
            getWalletBalance();
        }, (e) => {
            toast.error(e.message);
            setLoading(false);
        });
    }
    const getPlayerDetails = () => {
        callGetApi(PLAYER_PROFILE_GET, {}, (response) => {
            if (response.errorCode === STATUS.SUCCESS) {
                setProfileDetails({ ...response.responsePacket });
            }
        });
    }
    useEffect(() => {
        getPlayerDetails();
    }, []);
    // useEffect(() => {
    //     setAmount(walletBalance.toFixed(2) || "")
    // }, [walletBalance]);


    const txnHistory = () => {
        // if (startDate && endDate) {
        // Convert dates to timestamps
        const startTimestamp = new Date(startDate).getTime();
        const endTimestamp = new Date(endDate + 'T23:59:59').getTime(); // End of day

        callPostApi(PLAYER_WITHDRAWAL_HISTORY_POST, {
            pageSize: pageSize,
            pageNumber: pageNumber - 1
        }, {}, (response) => {
            setTransactions(response.responsePacket.data);
            setTotalPages(response.responsePacket.totalPages);
        });
        //    }

    }

    // API call when dates change
    useEffect(() => {
        txnHistory();
    }, [startDate, endDate, transactionType, pageSize, pageNumber]);
    return (
        <div className=' row'>
            <div className=' col-10'>
                <div className='main-div-content'>
                    <div>
                        <div className="deposit-tabs">
                            <button
                                className={activeTab === "withdrawal" ? "active" : ""}
                                onClick={() => setActiveTab("withdrawal")}
                            >Withdraw Móney
                            </button>
                            <button
                                className={activeTab === "history" ? "active" : ""}
                                onClick={() => setActiveTab("history")}
                            >
                                História
                            </button>
                        </div>

                        {activeTab === "withdrawal" && (
                            <>
                                {/* Payment Method */}
                                <div className="p-2 border-light rounded-2 mb-3" style={{ background: "#2F2F2F" }}>
                                    <div className="payment-methods">
                                        <div className="payment-method selected">
                                            <img src={paymentMethod.logo} alt={paymentMethod.name} />
                                            {/* <span style={{ marginLeft: 8 }}>{paymentMethod.name}</span> */}
                                            <span className="checkmark">✔</span>
                                        </div>
                                    </div>
                                    <div className="payment-limits mb-0">
                                        Pix &nbsp; Min: {getCurrencySymbol(globalProfileDetails?.currencyCode)} 10,00 &nbsp;
                                    </div>
                                </div>

                                {/* Insufficient Balance Warning */}
                                {walletBalance < minWithdrawBalance ? (
                                    <div className="withdraw-warning">
                                        <div className="warning-icon">
                                            <img style={{ width: "100px" }} src="../assets/img/withdrawal-img.png" alt="" />
                                        </div>
                                        <div>
                                            <div className="warning-title">Insufficient balance for withdrawal</div>
                                            <div className="warning-desc">
                                                Your balance is below the minimum amount of {getCurrencySymbol(globalProfileDetails?.currencyCode)} 10,00 for the payment system PAYBROKERS. Come back here after a few more wins.
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="deposit-form">
                                        <div className="deposit-input-row">
                                            <span className="currency-prefix">{getCurrencySymbol(globalProfileDetails?.currencyCode)}</span>
                                            <input
                                                id="withdraw-amount"
                                                type="number"
                                                value={amount}
                                                onChange={(e) => handleAmountChange(e.target.value)}
                                                placeholder="0.00"
                                            />
                                        </div>

                                        <button
                                            className="deposit-btn"
                                            disabled={!amount || amount < minWithdrawBalance || loading}
                                            onClick={handleWithdraw}
                                        >
                                            {loading ? <div className="spinner-border" /> : "WITHDRAW"}
                                        </button>
                                    </div>
                                )}
                            </>
                        )}

                        {activeTab === "history" && (
                            <>
                                <div style={{ background: "#2F2F2F", borderRadius: "10px", overflow: "auto" }} className="pb-2 px-2 account-statement-transactions">
                                    <table className="transaction-table table">
                                        {transactions && transactions.length > 0 && <thead className=''>
                                            <tr>
                                                <th>Amount</th>
                                                <th>Date</th>
                                                <th>Account Holder Name</th>
                                                <th>Customer Mobile</th>
                                                <th>Account Type</th>
                                                <th>Payment Status</th>
                                                <th>Transaction Ref ID</th>
                                            </tr>
                                        </thead>}
                                        <tbody className='table-bordered'>
                                            {transactions && transactions.length > 0 && transactions.map((transaction, index) => (
                                                <tr key={index} className="transaction-row">
                                                    <td className={`transaction-amount  ${transaction.amount >= 0 ? 'positive' : 'negative'}`}>
                                                        {getCurrencySymbol(globalProfileDetails?.currencyCode)} {Math.abs(transaction.amount).toFixed(2)}
                                                    </td>
                                                    <td className="transaction-date ">{new Date(transaction.createdAtTimeStamp).toLocaleDateString('pt-BR') + ' ' + new Date(transaction.createdAtTimeStamp).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) || 'N/A'}</td>
                                                    <td className="customer-name ">{transaction.accountHolderName || 'N/A'}</td>
                                                    <td className="customer-mobile ">{transaction.playerMobile || 'N/A'}</td>
                                                    <td className="payment-gateway ">{transaction.accountType || 'N/A'}</td>
                                                    {/* <td className="payment-status ">
                                                <span className={`status-badge  ${transaction.withdrawTransactionStatus?.toLowerCase()}`}>
                                                    {transaction.withdrawTransactionStatus || 'N/A'}
                                                </span>
                                            </td> */}
                                                    <td className="payment-status ">
                                                        <span
                                                            className={`status-badge ${transaction.withdrawTransactionStatus?.toLowerCase()}`}
                                                            style={{
                                                                color: '#fff',
                                                                color:
                                                                    transaction.withdrawTransactionStatus?.toLowerCase() === 'pending' ? '#dc3545' : // red
                                                                        transaction.withdrawTransactionStatus?.toLowerCase() === 'approved' ? '#28a745' : // green
                                                                            transaction.withdrawTransactionStatus?.toLowerCase() === 'rejected' ? '#ffc107' : // yellow
                                                                                undefined
                                                            }}
                                                        >
                                                            <span className="d-flex status">
                                                                <span><svg width="16" height="16" viewBox="0 0 16 16" style={{ verticalAlign: 'middle', marginRight: 4 }}>
                                                                    <circle cx="8" cy="8" r="8" fill="#b91c1c" />
                                                                    <line x1="5.5" y1="5.5" x2="10.5" y2="10.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                                                                    <line x1="10.5" y1="5.5" x2="5.5" y2="10.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                                                                </svg></span>
                                                                {transaction.withdrawTransactionStatus || 'N/A'}
                                                            </span>

                                                        </span>
                                                    </td>
                                                    <td className="transaction-ref-id ">{transaction.id || 'N/A'}</td>
                                                </tr>
                                            ))}
                                            {transactions && transactions.length === 0 && (
                                                <tr>
                                                    <td colSpan="7" className="text-center">No transactions found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className='d-flex gap-4 mt-4 mb-4 justify-content-end'>
                                    <span className='text-white'>Items Per Page 10</span>
                                    <span className='text-white'>{pageNumber} of {totalPages}</span>
                                    <div className='d-flex gap-4 font-weight-bold'>
                                        <span
                                            onClick={() => pageNumber > 1 && setPageNumber(1)}
                                            className={`h-16 w-16 text-white cursor-pointer ${pageNumber <= 1 ? 'opacity-50' : ''}`}
                                            style={{ cursor: pageNumber <= 1 ? 'not-allowed' : 'pointer' }}
                                        >
                                            {"<<"}
                                        </span>
                                        <span
                                            onClick={() => pageNumber > 1 && setPageNumber(pageNumber - 1)}
                                            className={`h-16 w-16 text-white cursor-pointer ${pageNumber <= 1 ? 'opacity-50' : ''}`}
                                            style={{ cursor: pageNumber <= 1 ? 'not-allowed' : 'pointer' }}
                                        >
                                            {"<"}
                                        </span>
                                        <span
                                            onClick={() => pageNumber < totalPages && setPageNumber(pageNumber + 1)}
                                            className={`h-16 w-16 text-white cursor-pointer ${pageNumber >= totalPages ? 'opacity-50' : ''}`}
                                            style={{ cursor: pageNumber >= totalPages ? 'not-allowed' : 'pointer' }}
                                        >
                                            {">"}
                                        </span>
                                        <span
                                            onClick={() => pageNumber < totalPages && setPageNumber(totalPages)}
                                            className={`h-16 w-16 text-white cursor-pointer ${pageNumber >= totalPages ? 'opacity-50' : ''}`}
                                            style={{ cursor: pageNumber >= totalPages ? 'not-allowed' : 'pointer' }}
                                        >
                                            {">>"}
                                        </span>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>

                </div>
            </div>
            <div className="col-2">
                <div className="p-2" style={{ background: "#1A1A1A", color: "#fff", borderRadius: "8px" }}>
                    <div style={{ background: "#2F2F2F", borderRadius: "8px" }} className="p-2">
                        <span className="balance-label" style={{ fontSize: "14px", color: "#B0B0B0" }}>
                            {profileDetails?.fullName}
                        </span>
                        <div className="d-flex  align-items-center justify-content-between">
                            <span
                                className="balance-amount"
                                style={{
                                    transition: "all 0.3s ease",
                                    opacity: hiddenBalance ? 0.7 : 1,
                                    letterSpacing: hiddenBalance ? "2px" : "normal",
                                    transform: hiddenBalance ? "scale(0.95)" : "scale(1)",
                                    filter: hiddenBalance ? "blur(0.5px)" : "blur(0px)"
                                }}
                            >
                                {hiddenBalance ? "••••" : getCurrencySymbol(globalProfileDetails?.currencyCode) + " " + walletBalance?.toFixed(2)}
                            </span>
                            <div className="balance-actions d-flex gap-2" style={{ alignItems: "center" }}>
                                <svg
                                    onClick={() => setHiddenBalance(!hiddenBalance)}
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    style={{
                                        cursor: "pointer",
                                        opacity: 0.8,
                                        transition: "all 0.2s ease",
                                        padding: "2px",
                                        borderRadius: "4px"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.opacity = "1";
                                        e.target.style.background = "rgba(255,255,255,0.1)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.opacity = "0.8";
                                        e.target.style.background = "transparent";
                                    }}
                                    title={hiddenBalance ? "Show Balance" : "Hide Balance"}
                                >
                                    {hiddenBalance ? (
                                        // Eye-off icon when balance is hidden
                                        <>
                                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </>
                                    ) : (
                                        // Eye icon when balance is visible
                                        <>
                                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </>
                                    )}
                                </svg>
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    onClick={() => getWalletBalance()}
                                    style={{
                                        cursor: "pointer",
                                        opacity: 0.8,
                                        transition: "all 0.2s ease",
                                        padding: "2px",
                                        borderRadius: "4px"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.opacity = "1";
                                        e.target.style.background = "rgba(255,255,255,0.1)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.opacity = "0.8";
                                        e.target.style.background = "transparent";
                                    }}
                                    title="Refresh Balance"
                                >
                                    <path d="M23 4v6h-6M1 20v-6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Withdraw